module.exports = "/dist/911dffc57b3739f0f1faa1a23e5d6dbc.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100italic.eot
// module id = 7
// module chunks = 0